var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHockey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8499 1.68876L6.82489 19H0V14.7777H5.77506L15.1199 0L17.8499 1.68876ZM15.2249 14.7777H21V19H14.1751L11.76 15.1999L13.6501 12.2444L15.2249 14.7777ZM13.1247 15.2019L14.8069 17.8485H19.8493V15.9292H14.5858L13.636 14.4021L13.1247 15.2019ZM6.40855 15.9292H1.15068V17.8485H6.19392L16.2526 2.05423L15.4834 1.57855L6.40855 15.9292ZM9.3451 5.38339L7.45501 8.33893L3.25512 1.68876L5.88012 0L9.3451 5.38339ZM4.8376 2.03933L7.46091 6.19305L7.97754 5.38536L5.53514 1.59064L4.8376 2.03933Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8499 1.68876L6.82489 19H0V14.7777H5.77506L15.1199 0L17.8499 1.68876ZM15.2249 14.7777H21V19H14.1751L11.76 15.1999L13.6501 12.2444L15.2249 14.7777ZM13.1247 15.2019L14.8069 17.8485H19.8493V15.9292H14.5858L13.636 14.4021L13.1247 15.2019ZM6.40855 15.9292H1.15068V17.8485H6.19392L16.2526 2.05423L15.4834 1.57855L6.40855 15.9292ZM9.3451 5.38339L7.45501 8.33893L3.25512 1.68876L5.88012 0L9.3451 5.38339ZM4.8376 2.03933L7.46091 6.19305L7.97754 5.38536L5.53514 1.59064L4.8376 2.03933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHockey);
export default __webpack_public_path__ + "static/media/hockey.f1e2c24ce65805212d1081cdf369a4c6.svg";
export { ForwardRef as ReactComponent };